import { configureStore } from '@reduxjs/toolkit'
import slice from './slice'

export default configureStore({
  reducer: {
    //is the same as "slice"
    slice: slice 
  },
})